import script from "./OCriarEventoPlanejado.vue?vue&type=script&lang=ts&setup=true"
export * from "./OCriarEventoPlanejado.vue?vue&type=script&lang=ts&setup=true"

import "./OCriarEventoPlanejado.vue?vue&type=style&index=0&id=02394454&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02394454"]])

export default __exports__